<script>
import bookingNew from '@/views/cargo/v0/SeaExport/bookingNew'

export default {
  name: 'FBABookingNew',
  extends: bookingNew
}
</script>
